import { render, staticRenderFns } from "./pay-detail.vue?vue&type=template&id=67847b40&scoped=true"
import script from "./pay-detail.vue?vue&type=script&lang=js"
export * from "./pay-detail.vue?vue&type=script&lang=js"
import style0 from "./pay-detail.vue?vue&type=style&index=0&id=67847b40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67847b40",
  null
  
)

export default component.exports